import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { LanguageService } from '@shared/services/language.service';
import { CoreModule } from '@core/core.module';
import { OtherLayoutComponent } from '@layouts/other-layout/other-layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { TicketsModule } from '@routes/tickets/tickets.module';
import { ComponentsModule } from '@components/components.module';
import { HeaderComponent } from '@layouts/main-layout/header/header.component';
import { MainLayoutTemplateComponent } from '@layouts/main-layout/main-layout.template.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { MenuComponent } from './menu/menu.component';
import { DialogsModule } from '@routes/dialogs/dialogs.module';
import { B2bMainLayoutComponent } from './b2b-main-layout/b2b-main-layout.component';
import { B2bSidebarComponent } from './b2b-main-layout/b2b-sidebar/b2b-sidebar.component';
import { B2bTopbarComponent } from './b2b-main-layout/b2b-topbar/b2b-topbar.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    LayoutComponent,
    TopbarComponent,
    SidebarComponent,
    OtherLayoutComponent,
    MainLayoutComponent,
    MainLayoutTemplateComponent,
    HeaderComponent,
    AuthLayoutComponent,
    MenuComponent,
    B2bMainLayoutComponent,
    B2bSidebarComponent,
    B2bTopbarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    CoreModule,
    TicketsModule,
    ComponentsModule,
    DialogsModule,
    MatTooltipModule,
  ],
  providers: [
    LanguageService
  ],
})
export class LayoutsModule {
}
